
import { Component, Prop, Vue } from 'vue-property-decorator';
import { links } from '@/configs/links';
import DescriptionBlockV from './description-block.vue';
import StorylinesV from './storylines.vue';
import RampMapV from '@/components/map.vue';
import ToggleVersionV from './toggle-version.vue';

@Component({
    components: {
        'description-block': DescriptionBlockV,
        storylines: StorylinesV,
        'ramp-map': RampMapV,
        'toggle-version': ToggleVersionV
    }
})
export default class InfoFeatureV extends Vue {
    @Prop() index!: number;
    @Prop() section!: any;

    isVisible = false;
    links = links;
    previousScrollPosition = 0;
    version = 4;
    show = false;

    openRAMP3() {
        this.version = 3;
    }

    openRAMP4() {
        this.version = 4;
    }

    beforeUpdate() {
        if (this.isVisible) {
            this.previousScrollPosition = window.scrollY;
        }
    }

    updated() {
        if (this.isVisible) {
            window.scrollTo(0, this.previousScrollPosition);
        }
    }

    mounted() {
        setTimeout(() => {
            this.show = true;
        }, 1500);

        let timeoutID = 0;
        const callback = (entries: any) => {
            const [entry] = entries;
            if (entry.isIntersecting) {
                timeoutID = setTimeout(() => {
                    this.isVisible = true;
                }, 500);
            } else {
                clearTimeout(timeoutID);
                this.isVisible = false;
                this.version = 4;
            }
        };

        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        let observer = new IntersectionObserver(callback, options);
        let target = this.$el.querySelector(`[id="ramp-maps-${this.index}"]`);
        if (target) {
            observer.observe(target);
        }
    }
}
